import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import useClient from '@pkg/client/useClient';
import invalidateSupporterQueries from '../invalidateSupporterQueries';

/**
 * @returns {Function}
 */
export default function useAddGroupSupporter() {
  const client = useClient();
  const queries = useQueryClient();

  /**
   * @param {String} designId
   * @param {String} groupId
   * @param {String} userId
   * @returns {Object}
   */
  async function onAdd(designId, groupId, userId) {
    const result = await client.put(
      `v1/designs/${designId}/groups/${groupId}/supporters/${userId}`
    );

    if (result?.status === 200) {
      invalidateSupporterQueries(queries, designId, groupId);
    }

    return result;
  }

  return useCallback(onAdd, [client, queries]);
}
